// extracted by mini-css-extract-plugin
export var close = "Search-module--close--bbbd8";
export var el = "Search-module--el--d3a52";
export var open = "Search-module--open--8ed6b";
export var query = "Search-module--query--f99cf";
export var result = "Search-module--result--cf188";
export var results = "Search-module--results--8cb3d";
export var sub = "Search-module--sub--af075";